import { useQuery } from "@tanstack/react-query";
import { getAircraftLogs } from "../../api";

export interface GetFleetLogbookPayload {
  aircraftIds: string[],
  from: string,
  to: string,
  columns: string[],
  noTotals: boolean
}

const useQueryGetFleetLogbook = ({ payload }: { payload: GetFleetLogbookPayload }):
  { data: Record<string, string | number>[]; selectableColumns: string[]; isFetching: boolean } => {

  const { data: response, isFetching } = useQuery({
    queryKey: ['fleetLogbook', payload],
    queryFn: async () => {
      try {
        const result = await getAircraftLogs(payload);
        return result || { data: [], selectableColumns: [], chosenColumns: [] };
      } catch (error) {
        console.error('Error fetching fleet logbook:', error);
        return { data: [], selectableColumns: [], chosenColumns: [] };
      }
    },
    refetchOnWindowFocus: false,
    staleTime: 30000,
    enabled: payload?.aircraftIds?.length > 0,
  });

  return {
    data: response?.data,
    selectableColumns: response?.selectableColumns,
    isFetching,
  };
};

export default useQueryGetFleetLogbook;
